import type React from "react"

import { MAX_MONTHS_IN_RANGE } from "@/utils/constants"

import { Box, Typography } from "@mui/material"

import emptyCity from "../../assets/city street-gray.svg"

interface EmptyChartProps {
  header?: string
  subHeader?: string
}

export const DATE_PICKER_ERROR_MESSAGE = `Must be within ${MAX_MONTHS_IN_RANGE} months`
export const EMPTY_HEADER = "There is no activity data available for this site."
export const DATE_RANGE_ERROR_SUBHEADER =
  "Please select a different date range."
export const DEFAULT_HEADER = "Data Unavailable"

const EmptyChart: React.FC<EmptyChartProps> = ({ header, subHeader }) => (
  <Box
    sx={(theme) => ({
      color: theme.palette.text.secondary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    })}
  >
    <Typography
      variant="h2"
      sx={{
        mb: 1,
      }}
    >
      {header ?? DEFAULT_HEADER}
    </Typography>
    {subHeader && (
      <Typography
        component="span"
        variant="h4"
        sx={{
          mb: 1,
          fontStyle: "italic",
        }}
      >
        {subHeader}
      </Typography>
    )}
    <img
      alt=""
      aria-hidden="true"
      // migration to strict mode batch disable

      src={emptyCity}
    />
  </Box>
)

export default EmptyChart
